module.exports = __webpack_public_path__ + "static/media/undraw_superhero_amber.23333259.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Illustration/img/undraw_superhero_amber.svg
// module id = 1098
// module chunks = 2